/**
 * @generated SignedSource<<e7f0965aae4b0fd2855f8b006f6ca7ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventType = "OCCURRENCE" | "RECURRING" | "SINGLE";
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type MeetingHeader_note$data = {
  readonly event: {
    readonly guid: string;
    readonly type: EventType;
    readonly " $fragmentSpreads": FragmentRefs<"JoinConferenceButton_event">;
  } | null;
  readonly id: string;
  readonly noteType: NoteStreamType;
  readonly stream: {
    readonly id: string;
    readonly notesCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"MeetingTitleAndXWCSwitcher_stream">;
  };
  readonly title: string;
  readonly url: string | null;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"Attendees_note" | "MeetingDateOrTimer_note" | "MoreActionsMenu_MeetingHeader_note" | "SeriesExplorer_note" | "ShareButton_note">;
  readonly " $fragmentType": "MeetingHeader_note";
};
export type MeetingHeader_note$key = {
  readonly " $data"?: MeetingHeader_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingHeader_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingHeader_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notesCount",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingTitleAndXWCSwitcher_stream"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "guid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JoinConferenceButton_event"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeriesExplorer_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingDateOrTimer_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Attendees_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareButton_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MoreActionsMenu_MeetingHeader_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "2cf08e209c1a8e770b45841a8b9c4599";

export default node;
